import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const Implementacion = () => {
  const incluye = [
    {
      title: "Diagnóstico inicial",
      description: "Auditoría de tus procesos actuales para detectar fugas de eficiencia."
    },
    {
      title: "6 Sesiones privadas",
      description: "Mentoría directa con @tecnoabogado y Luis para la implementación técnica."
    },
    {
      title: "Ecosistema listo para usar",
      description: "Entrega de tu panel de control con las IAs configuradas."
    },
    {
      title: "Soporte prioritario",
      description: "Acceso directo para resolver dudas técnicas durante la fase crítica de despliegue."
    }
  ];

  const beneficios = [
    "Configuración de flujos seguros de trabajo (safer-ia)",
    "Creación de agentes personalizados para redacción procesal",
    "Estrategia de pricing basada en eficiencia sintética",
    "Biblioteca de habilidades jurídicas personalizada",
    "Integración con la mayoría de las herramientas actuales",
    "Plan de escalabilidad a medio plazo"
  ];

  const scrollToContacto = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="implementacion" className="bg-reset-black py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="border-b border-reset-gold/20 pb-12 mb-12">
          <span className="text-reset-gold uppercase tracking-widest text-sm mb-4 block">
            Servicio exclusivo de consultoría
          </span>
          <h2 className="text-5xl md:text-6xl font-light text-white leading-tight">
            Implementación <span className="italic text-reset-gold">tecnojurídica</span> 1 a 1
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Left Column */}
          <div>
            <p className="text-xl text-gray-400 leading-relaxed mb-8">
              Un proceso de transformación de cuatro semanas donde pasamos de la teoría a la ejecución real en tu despacho. Sin rodeos.
            </p>
            
            <h3 className="text-2xl font-semibold text-white mb-6">
              ¿Qué incluye?
            </h3>
            <div className="space-y-4 mb-8">
              {incluye.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="text-reset-gold shrink-0 mt-1" size={20} />
                  <div>
                    <p className="text-white font-semibold">{item.title}</p>
                    <p className="text-gray-400 text-sm">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div>
            <h3 className="text-2xl font-semibold text-white mb-6">
              Lo que conseguirás
            </h3>
            <div className="space-y-3 mb-8">
              {beneficios.map((beneficio, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="h-6 w-6 rounded-full border-2 border-reset-gold shrink-0 mt-0.5" />
                  <p className="text-gray-300">{beneficio}</p>
                </div>
              ))}
            </div>

            {/* Social Proof Box */}
            <div className="bg-reset-dark border border-reset-gold/30 p-6 mt-8">
              <p className="text-white font-semibold mb-2">
                Garantía de rigor jurídico
              </p>
              <p className="text-gray-400 text-sm leading-relaxed">
                Todo el despliegue se realiza bajo la normativa española de protección de datos y el código deontológico de la abogacía. Somos abogados que hablan código, no informáticos que intentan entender leyes.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button 
            onClick={scrollToContacto}
            data-testid="implementacion-cta-button"
            className="bg-reset-gold hover:bg-reset-gold-light text-black px-12 py-5 text-xl font-bold transition-all inline-flex items-center gap-3 group"
          >
            Solicitar acceso prioritario
            <ArrowRight className="group-hover:translate-x-1 transition-transform" size={24} />
          </button>
          <p className="text-gray-500 text-sm mt-4">
            Plazas limitadas • Próximo inicio disponible
          </p>
        </div>
      </div>
    </section>
  );
};

export default Implementacion;